// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"657":"7e5f0408","4797":"6e8d7965","6367":"7e5f0408"}[chunkId] + ".chunk.css";
};